import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  SuperAdminManageRouteList,
  aclLink,
  batchAclLink,
  cameraLink,
  cameraManagementRouteList,
  eventLogLink,
  superAdminLink,
  userLink,
  userManagementRouteList
} from '../../../../router/routerLink';
import {matchPath, useLocation, useNavigate} from 'react-router-dom';

import MenuIcon from './MenuIcon';
import aclActiveIcon from '../../../../icons/aclActive.svg';
import aclDefaultIcon from '../../../../icons/aclDefault.svg';
import aclHoverIcon from '../../../../icons/aclHover.svg';
import camActiveIcon from '../../../../icons/camActive.svg';
import camDefaultIcon from '../../../../icons/camDefault.svg';
import camHoverIcon from '../../../../icons/camHover.svg';
import eventLogActiveIcon from '../../../../icons/eventLogActive.svg';
import eventLogDefaultIcon from '../../../../icons/eventLogDefault.svg';
import eventLogHoverIcon from '../../../../icons/eventLogHover.svg';
import { hasSuperAdminAccess } from 'src/core/PermissionHandler';
import superAdminActiveIcon from '../../../../icons/superadminActive.svg';
import superAdminDefaultIcon from '../../../../icons/superAdminDefault.svg';
import superAdminHoverIcon from '../../../../icons/superAdminHover.svg';
import userActiveIcon from '../../../../icons/userActive.svg';
import userDefaultIcon from '../../../../icons/userDefault.svg';
import userHoverIcon from '../../../../icons/userHover.svg';

export const SideBarManagementMenu = () => {
  const isSuperAdmin = hasSuperAdminAccess();
  const [isUserSelected, setIsUserSelected] = useState(false)
  const [isCamSelected, setIsCamSelected] = useState(false)
  const [isAclSelected, setIsAclSelected] = useState(false)
  const [isEventSelected, setIsEventSelected] = useState(false)
  const [isSuperSelected, setIsSuperSelected] = useState(false)
  const [isUserHover, setIsUserHover] = useState(false)
  const [isCamHover, setIsCamHover] = useState(false)
  const [isAclHover, setIsAclHover] = useState(false)
  const [isEventHover, setIsEventHover] = useState(false)
  const [isSuperHover, setIsSuperHover] = useState(false)
  const navigate = useNavigate();
  const subManageMenuItems = [
    {
      name: 'Users',
      image: userDefaultIcon,
      hoverImage: userHoverIcon,
      selectedImage: userActiveIcon,
      alt: "users",
      link: userLink,
      isSelected: isUserSelected,
      isButtonHover: isUserHover,
      setIsButtonHover: setIsUserHover
    },
    {
      name: 'Cameras',
      image: camDefaultIcon,
      hoverImage: camHoverIcon,
      selectedImage: camActiveIcon,
      alt: "cameras",
      link: cameraLink,
      isSelected: isCamSelected,
      isButtonHover: isCamHover,
      setIsButtonHover: setIsCamHover
    },
    {
      name: 'Access Control',
      image: aclDefaultIcon,
      hoverImage: aclHoverIcon,
      selectedImage: aclActiveIcon,
      alt: "access",
      link: aclLink,
      isSelected: isAclSelected,
      isButtonHover: isAclHover,
      setIsButtonHover: setIsAclHover
    },
    {
      name: 'Event Log',
      image: eventLogDefaultIcon,
      hoverImage: eventLogHoverIcon,
      selectedImage: eventLogActiveIcon,
      alt: "eventLog",
      link: eventLogLink,
      isSelected: isEventSelected,
      isButtonHover: isEventHover,
      setIsButtonHover: setIsEventHover
    },
    {
      name: 'Super Admin',
      image: superAdminDefaultIcon,
      hoverImage: superAdminHoverIcon,
      selectedImage: superAdminActiveIcon,
      alt: "superAdmin",
      link: superAdminLink,
      isSelected: isSuperSelected,
      isButtonHover: isSuperHover,
      setIsButtonHover: setIsSuperHover
    },
  ];

  const location = useLocation();
  useEffect(() => {
    setIsUserSelected(false)
    setIsCamSelected(false)
    setIsSuperSelected(false)
    userManagementRouteList.forEach(u => {
      const match = matchPath({
        path: u,
        end: true
      }, location.pathname);
      if (match) {
        setIsUserSelected(true)
      }
    })
    cameraManagementRouteList.forEach(c => {
      const match = matchPath({
        path: c,
        end: true
      }, location.pathname);
      if (match) {
        setIsCamSelected(true)
      }
    })
    SuperAdminManageRouteList.forEach(c => {
      const match = matchPath({
        path: c,
        end: true
      }, location.pathname);
      if (match) {
        setIsSuperSelected(true)
      }
    })
    location.pathname == aclLink || location.pathname == batchAclLink ? setIsAclSelected(true) : setIsAclSelected(false)
    location.pathname == eventLogLink ? setIsEventSelected(true) : setIsEventSelected(false)

    const path = location.pathname.split("/", 2).pop();
    subManageMenuItems.forEach((s) => {
      s.alt === path && setValue(s.link)
    });
  }, [location.pathname])

  const [value, setValue] = React.useState(location.pathname);
  const handleChange = (event, newValue) => {
    navigate(newValue);
  };
  let nonSuperAdminList = subManageMenuItems.slice(0, subManageMenuItems.length - 1);
  return (
    <Box
      sx={{
        dispaly: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px',  
        alignSelf: 'center', 
        justifyContent: 'center',
        '@media only screen and (max-width: 1280px)': {
          width: '700px',
        }
      }}
    >
      <Tabs variant="fullWidth" value={value} onChange={handleChange} centered sx={{ height: '45px', }}>
        {(isSuperAdmin ? subManageMenuItems : nonSuperAdminList).map((item) => {
          return (
            <Tab
              disableRipple
              onMouseOver={() => item.setIsButtonHover(true)}
              onMouseOut={() => item.setIsButtonHover(false)}
              value={item.link}
              key={item.link}
              label={item.name}
              icon={<MenuIcon
                defaultIcon={item.image}
                selected={item.selectedImage}
                hover={item.hoverImage}
                isSelected={item.isSelected}
                isButtonHover={item.isButtonHover}
              />}
              iconPosition="start"
              sx={{ 
                height: '45px',
                fontFamily: 'Lato',
                fontStyle: 'normal',
                fontSize: '16px',
                color: "#B2B7C2",
                fontWeight: 700,
                lineHeight: '22px',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                border: '1px solid #343B5E',
              }}
            />
          )
        })}
      </Tabs>
    </Box>
  );
};
export default SideBarManagementMenu;
